import type { CSSProperties } from 'react'
import type { Claim, Cited } from './data'
import { useT } from './i18n'
import { MONO } from './ui'

const citeStyle: CSSProperties = { fontFamily: MONO, fontSize: '0.72em', letterSpacing: '0.04em', whiteSpace: 'nowrap', verticalAlign: '0.08em' }

/** A small inline link to the source that says the preceding claim. Source labels are official titles: never translated. */
export function Cite({ c, style }: { c: Cited; style?: CSSProperties }) {
  const { t, date } = useT()
  return <a href={c.sourceUrl} target="_blank" rel="noreferrer" lang="en" className="cite" style={{ ...citeStyle, ...style }} title={t('cite.title', { label: c.sourceLabel, date: date(c.lastVerified) })}>[{c.sourceLabel}]</a>
}

/** Claims as running text, each followed by its own source. Consecutive claims from the same place share one link. */
export function Claims({ claims }: { claims: Claim[] }) {
  const { tc } = useT()
  return (
    <>
      {claims.map((c, i) => {
        const showCite = claims[i + 1]?.sourceLabel !== c.sourceLabel
        return <span key={i}>{tc(c)}{showCite && <>{' '}<Cite c={c} /></>}{i < claims.length - 1 ? ' ' : ''}</span>
      })}
    </>
  )
}
